<template>
  <div class="patrolDetails">
    <h2>巡检详情</h2>
    <h4 class="title">巡检人员信息</h4>
    <el-descriptions title="" border :column="1" style="width:70%">
      <el-descriptions-item label="人员信息">
        <el-table :data="executorData" style="width: 100%" size="mini">
          <el-table-column prop="department" label="部门"></el-table-column>
          <el-table-column prop="name" label="姓名"> </el-table-column>
          <el-table-column prop="phone" label="联系电话"> </el-table-column>
        </el-table>
      </el-descriptions-item>
    </el-descriptions>
    <h4 class="title">巡检内容</h4>
    <el-table
      :data="tableData"
      border
      style="width: 100%"
      size="mini"
      stripe
      :cell-style="cellStyle"
    >
      <el-table-column
        v-for="(v, i) in tabHead"
        :key="i"
        :prop="v.prop"
        :label="v.label"
        align="center"
      ></el-table-column>
    </el-table>
  </div>
</template>

<script>
export default {
  data() {
    return {
      executorData: [
        {
          department: "维修部",
          name: "王小虎",
          phone: "12345678934",
        },
        {
          department: "维修部",
          name: "张三",
          phone: "12345678934",
        },
      ],
      tabHead: [
        { label: "设备名称", prop: "name" },
        { label: "设备地址", prop: "address" },
        { label: "是否巡检", prop: "state" },
        { label: "巡检人", prop: "user" },
        { label: "巡检时间", prop: "time" },
        { label: "巡检备注", prop: "remarks" },
      ],
      tableData: [
        {
          name: "一楼照明设备",
          address: "一楼大厅",
          state: "否",
          user: "张三",
          time: "2022-03-05 12:00",
          remarks: "",
        },
        {
          name: "一楼照明设备",
          address: "一楼大厅",
          state: "否",
          user: "张三",
          time: "2022-03-05 12:00",
          remarks: "备注内容",
        },
        {
          name: "一楼照明设备",
          address: "一楼大厅",
          state: "否",
          user: "张三",
          time: "2022-03-05 12:00",
          remarks: "",
        },
        {
          name: "一楼照明设备",
          address: "一楼大厅",
          state: "否",
          user: "张三",
          time: "2022-03-05 12:00",
          remarks: "",
        },
      ],
    };
  },
  methods: {
    cellStyle(row) {},
  },
};
</script>

<style lang="scss" scoped>
.patrolDetails {
  width: 95%;
  margin: 0 auto;
  ::v-deep .el-descriptions {
    th {
      width: 120px;
    }
  }
  h2 {
    font-size: 22px;
    margin: 20px 0;
  }
  h3 {
    font-size: 18px;
  }
  .title {
    font-size: 16px;
    padding-left: 10px;
    border-left: 3px solid #3a72dd;
    margin: 20px 0;
  }
}
</style>